import { useMemo } from 'react';
import {
  BluetoothPrinterInfo,
  useBluetoothPrinter,
} from '../contexs/bluetooth-printer-context';
import { PrinterModelType } from '../api/types/vendor/printers.type';

export const useGroupedBluetoothPrinters = () => {
  const { printers } = useBluetoothPrinter();

  const groupedPrinters = useMemo(() => {
    const uniqueIdentifiers = new Set<string>();

    return printers.reduce<Record<PrinterModelType, BluetoothPrinterInfo[]>>(
      (printersByModel, printer) => {
        if (uniqueIdentifiers.has(printer.identifier)) {
          return printersByModel;
        }

        uniqueIdentifiers.add(printer.identifier);

        if (!printersByModel[printer.model]) {
          printersByModel[printer.model] = [];
        }

        printersByModel[printer.model].push(printer);
        return printersByModel;
      },
      {} as Record<PrinterModelType, BluetoothPrinterInfo[]>,
    );
  }, [printers]);

  const findByModel = (model: PrinterModelType) => groupedPrinters[model] || [];

  return {
    groupedPrinters,
    findByModel,
  };
};
